<template>
  <div class="animated fadeIn" id="faturamento-competencia">
    <div class="card card-default">
      <div class="card-header">
        <div class="card-header"><i class="fa fa-calendar"></i> Alocação</div>
      </div>
      <div class="card-body">
        <div class="input-group mb-3 d-flex align-items-center">
          <span class="input-group-text" id="competencia" style="width: 120px; margin-bottom: 20px">
            Competência
          </span>
          <date-picker
            input-class="form-control"
            v-model="competencia"
            lang="pt-br"
            format="MM/YYYY"
            type="month"
            @change="updateCompetencia"
            style="height: calc(40% - 90px); margin-bottom: 20px"
          ></date-picker>

          <b-dropdown
            :text="dropdownLabel"
            class="align-middle custom-dropdown"
            style="margin-left: 20px; margin-bottom: 20px"
            toggle-class="custom-dropdown-input"
            no-close-on-click
            no-auto-close="outside"
          >

            <!-- Botões de ação -->
            <b-dropdown-item-button @click="selecionarTodosUsuarios">
              <i class="fa fa-check-square mr-2"></i> Selecionar todos
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="limparUsuariosSelecionados">
              <i class="fa fa-times mr-2"></i> Limpar seleção
            </b-dropdown-item-button>

            <b-dropdown-divider></b-dropdown-divider>

            <!-- Lista de usuários com checkboxes -->
            <div v-for="usuario in usuarios" :key="`${checkboxRenderKey}-usuario-${usuario}`" class="px-3 py-1">
              <b-form-checkbox v-model="selectedUsuarios" :value="usuario">
                {{ usuario }}
              </b-form-checkbox>
            </div>
          </b-dropdown>

          <button class="btn btn-primary search-btn" style="margin-left: 10px; height: 36px; margin-bottom: 20px"
            @click="filtrar()" :disabled="isGenerating || !competencia">
            <i v-if="isGenerating" class="fa fa-spinner fa-spin"></i>
            <span v-else><i class="icon-magnifier"></i> Filtrar</span>
          </button>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered table-striped table-sm table-hover" v-if="arrayDados.length > 0">
            <thead>
              <tr>
                <th>Pessoa</th>
                <!-- Removido: <th class="col-tipo"></th> -->
                <th v-for="key in headers" :key="key" class="col-data">{{ key }}</th>
                <th class="col-total">Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, idx) in tableRows">
                <tr v-if="!row.isDetail" :key="'main-' + row.pessoa">
                  <td>
                    <b-button @click="toggleExpand(idx)" variant="link" class="text-left p-0">
                      <i :class="row.expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="mr-1"></i>
                      {{ row.pessoa }}
                    </b-button>
                  </td>
                  <!-- Removido: <td></td> -->
                  <td v-for="key in headers" :key="key" class="col-data">
                    {{ parseFloat(row[key] || 0).toFixed(2).replace(".", ",") }}
                  </td>
                  <td class="col-total">
                    {{ parseFloat(row.total || 0).toFixed(2).replace(".", ",") }}
                  </td>
                </tr>
                <tr v-else :key="'detail-' + row.parentPessoa + '-' + row.tipo" style="background: #f8f9fa;">
                  <td class="col-tipo"><strong>{{ row.tipo }}</strong></td>
                  <td v-for="key in headers" :key="key" class="col-data">
                    {{ parseFloat(row[key] || 0).toFixed(2).replace(".", ",") }}
                  </td>
                  <td class="col-total">
                    {{ parseFloat(row.total || 0).toFixed(2).replace(".", ",") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-end">
          <h5 v-if="arrayDados.length > 0" class="mr-2">Total Geral</h5>
          <h5 v-if="arrayDados.length > 0">
            {{arrayDados.reduce((sum, row) => sum + calculateTotal(row), 0).toFixed(2)
              .replace('.', ',')}}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Uteis from "@/mixins/utils.js";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    DatePicker,
  },
  mixins: [Uteis],
  name: "Orcamento",
  data() {
    return {
      competencia: null,
      periodoInicio: null,
      periodoFinal: null,
      isGenerating: false,
      arrayDados: [],
      headers: [],
      formatDateInicio: null,
      formatDateFinal: null,
      usuarios: [],
      selectedUsuarios: [],
      checkboxRenderKey: 0,
      expandedRows: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "pessoa", label: "Pessoa" },
        ...this.headers.map(h => ({ key: h, label: h, thClass: 'col-data', tdClass: 'col-data' })),
        { key: "total", label: "Total", thClass: 'col-total', tdClass: 'col-total' },
      ];
    },

    subFields() {
      return [
        {
          key: "tipo",
          label: "Tipo",
          tdClass: "col-tipo",
          thClass: "col-tipo",
          thStyle: { width: '80px', whiteSpace: 'nowrap' },
          tdStyle: { width: '100px', whiteSpace: 'nowrap' }
        },
        ...this.headers.map(h => ({
          key: h,
          label: h,
          tdClass: "col-data text-center",
          thClass: "col-data text-center",
          thStyle: { width: '10px', whiteSpace: 'nowrap' },
          tdStyle: { width: '100px', whiteSpace: 'nowrap' }
        })),
        {
          key: "total",
          label: "Total",
          tdClass: "col-total text-center",
          thClass: "col-total text-center",
          thStyle: { width: '20px', whiteSpace: 'nowrap' },
          tdStyle: { width: '200px', whiteSpace: 'nowrap' }

        },
      ];
    },

    dropdownLabel() {
      const total = this.selectedUsuarios.length;
      return total === 0
        ? "Selecionar usuários"
        : `${total} usuário${total > 1 ? "s" : ""} selecionado${total > 1 ? "s" : ""}`;
    },

    tableRows() {
      // Gera linhas principais e sublinhas (detalhes) para a tabela
      const rows = [];
      this.arrayDados.forEach((row, idx) => {
        rows.push({ ...row, expanded: this.expandedRows.includes(idx), isDetail: false });
        if (this.expandedRows.includes(idx)) {
          row.detalhes.forEach(detalhe => {
            rows.push({
              ...detalhe,
              isDetail: true,
              parentPessoa: row.pessoa
            });
          });
        }
      });
      return rows;
    }
  },

  async mounted() {
    await this.getUsuarios();
  },
  methods: {
    updateCompetencia(date) {
      if (date) {
        const competenciaDate = new Date(date);
  
        const inicio = new Date(competenciaDate);
        inicio.setMonth(inicio.getMonth() - 1);
        inicio.setDate(26);
        this.periodoInicio = inicio;
    
        const fim = new Date(competenciaDate);
        fim.setDate(25);
        this.periodoFinal = fim;
      } else {
        this.periodoInicio = null;
        this.periodoFinal = null;
      }
    },
    formatDate() {
      if (this.periodoInicio) {
        this.formatDateInicio = this.formatDateToISO(this.periodoInicio);
      }
      if (this.periodoFinal) {
        this.formatDateFinal = this.formatDateToISO(this.periodoFinal);
      }
    },
    formatDateToISO(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatWeekday(date) {
      let [day, month] = date.split("-");
      let year;
      if (month === "Dec" && parseInt(day) >= 26) {
        year = new Date(this.periodoInicio).getFullYear();
      } else {
        year = new Date(this.periodoFinal).getFullYear();
      }
      const formattedDate = new Date(`${year}-${month}-${day}`);
      return formattedDate.toLocaleDateString("pt-BR", { weekday: "short" });
    },
    async filtrar() {
      this.isGenerating = true;
      this.formatDate();

      const dto = {
        inicio: this.formatDateInicio,
        fim: this.formatDateFinal,
        usuarios: this.selectedUsuarios,
      };

      try {
        const responseTotal = await this.$http.get("/alocacao/relatorio-horas", {
          params: dto,
        });
        const responseHoras = await this.$http.get("/alocacao/relatorio-horas-usuario", {
          params: dto,
        });

        const totais = responseTotal.data;
        const horasDetalhadas = responseHoras.data;

        const primeiroItem = Object.values(totais)[0] || {};
        this.headers = Object.keys(primeiroItem).filter((key) => !['pessoa', 'total', 'detalhes'].includes(key));

        const headerParaDataISO = {};
        this.headers.forEach(header => {
          const [dia, mesAbrev] = header.split("-");
          const meses = {
            Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
            Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
          };
          const mesNum = meses[mesAbrev];
          const ano = dto.inicio.split("-")[0];
          const dataISO = `${ano}-${mesNum}-${dia}`;
          headerParaDataISO[header] = dataISO;
        });


        this.arrayDados = totais.map(item => {
          const row = {
            pessoa: item.pessoa,
            detalhes: [],
          };


          this.headers.forEach(key => {
            row[key] = parseFloat(item[key] || 0);
          });


          row.total = this.calculateTotal(row);


          const detalhesPessoa = horasDetalhadas.find(h => h.pessoa === item.pessoa);

          if (detalhesPessoa) {
            const detalhesPorTipo = {};

            for (const [dataISO, tipos] of Object.entries(detalhesPessoa.datas)) {
              for (const [tipo, horas] of Object.entries(tipos)) {
                if (!detalhesPorTipo[tipo]) {
                  detalhesPorTipo[tipo] = {};
                }

                const found = Object.entries(headerParaDataISO)
                  .find(([header, iso]) => iso === dataISO);
                const headerCorrespondente = found ? found[0] : undefined;

                if (headerCorrespondente) {
                  detalhesPorTipo[tipo][headerCorrespondente] = parseFloat(horas.horas || 0);
                }
              }
            }

            const tiposOrdenados = Object.entries(detalhesPorTipo).sort((a, b) => {
              if (a[0] < b[0]) return -1;
              if (a[0] > b[0]) return 1;
              return 0;
            });

            row.detalhes = tiposOrdenados.map(([tipo, valores]) => {
              const detalhe = { tipo };

              this.headers.forEach(key => {
                detalhe[key] = valores[key] || 0;
              });

              detalhe.total = this.calculateTotal(detalhe);
              return detalhe;
            });
          }

          return row;
        });

      } catch (error) {
        console.error("Erro ao filtrar dados:", error);
      } finally {
        this.isGenerating = false;
      }
    },
    calculateTotal(row) {
      return Object.entries(row)
        .filter(([key]) => this.headers.includes(key))
        .reduce((sum, [, current]) => {
          const num = parseFloat(current);
          return sum + (isNaN(num) ? 0 : num);
        }, 0);
    },
    async getUsuarios() {
      const responseHoras = await this.$http.get("/alocacao/usuarios");
      this.usuarios = responseHoras.data.sort((a, b) => a.localeCompare(b));
    },
    onUsuarioChange(usuario, isChecked) {
      const index = this.selectedUsuarios.indexOf(usuario);
      if (isChecked && index === -1) {
        this.selectedUsuarios.push(usuario);
      } else if (!isChecked && index !== -1) {
        this.selectedUsuarios.splice(index, 1);
      }
    },
    selecionarTodosUsuarios() {
      this.selectedUsuarios = this.usuarios.slice();
      this.checkboxRenderKey++;
    },
    limparUsuariosSelecionados() {
      this.selectedUsuarios = [];
      this.checkboxRenderKey++;
    },
    toggleExpand(idx) {
      const i = this.expandedRows.indexOf(idx);
      if (i === -1) {
        this.expandedRows.push(idx);
      } else {
        this.expandedRows.splice(i, 1);
      }
    },
  },
};
</script>

<style>
.col-tipo {
  white-space: nowrap;
  padding: 4px 8px;
  box-sizing: border-box;
  width: 418px;
}

.col-data {
  width: 20px;
  text-align: right;
  white-space: nowrap;
  padding: 4px 8px;
  box-sizing: border-box;
}

/* Colunas de horas apenas nos detalhes (dropdown) */
.b-table-details .col-data {
  width: 80px;
}

.col-total {
  width: 20px;
  font-weight: bold;
  text-align: right;
  white-space: nowrap;
  padding: 4px 8px;
  box-sizing: border-box;
}

table {
  border-collapse: collapse;
}

/* Customização do dropdown */
.custom-dropdown .dropdown-toggle {
  background-color: transparent !important;
  border: 1px solid #6c757d !important;
  color: #6c757d !important;
  border-radius: 4px;
}

.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active {
  background-color: transparent !important;
  border-color: #6c757d !important;
  color: #6c757d !important;
  box-shadow: none !important;
}

/* Customização do botão quando está aberto */
.custom-dropdown.show .dropdown-toggle {
  background-color: transparent !important;
  border-color: #6c757d !important;
  color: #6c757d !important;
}

/* Customização do menu dropdown */
.custom-dropdown .dropdown-menu {
  border: 1px solid #6c757d;
  border-radius: 4px;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}
</style>
